import { render, staticRenderFns } from "./RuleListView.vue?vue&type=template&id=3821788c&scoped=true&"
import script from "./RuleListView.vue?vue&type=script&lang=js&"
export * from "./RuleListView.vue?vue&type=script&lang=js&"
import style0 from "./RuleListView.vue?vue&type=style&index=0&id=3821788c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821788c",
  null
  
)

/* custom blocks */
import block0 from "./RuleListView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports